import React from 'react';
import HelpIcon from '@material-ui/icons/Help';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

const withTooltip =
  (WrappedComponent) =>
  ({ tooltip, ...otherProps }) =>
    tooltip && tooltip.length > 0 ? (
      <div>
        <WrappedComponent {...otherProps} />
        <Tooltip title={tooltip}>
          <IconButton aria-label={tooltip} mini>
            <HelpIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>
    ) : (
      <WrappedComponent {...otherProps} />
    );

export default withTooltip;



// WEBPACK FOOTER //
// ./src/view/forms/components/withTooltip.js